import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

export default function Header() {
  let [active, setActive] = useState(false);
  let [show, setShow] = useState(true);
  let [lastScrollTop, setLastScrollTop] = useState(window.pageYOffset);

  const handleClick = () => {
    setActive((active = !active));
  };

  const handleNav = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 600 || scrollTop < 20) {
      setShow(true);
    } else {
      setShow(false);
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleNav);
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className={`${show ? '' : 'nav-hide'} ${
        lastScrollTop > 600 ? 'nav-bg' : ''
      } navbar`}
    >
      <nav className="container">
        <div className="logo">
          <a href="/">TAP</a>
        </div>
        <ul className={active ? 'nav-links nav-links-active' : 'nav-links'}>
          <li>
            <Link
              className="link "
              activeClass={'active-link'}
              spy={true}
              smooth={true}
              duration={300}
              offset={-100}
              to="home"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              className="link"
              activeClass={'active-link'}
              spy={true}
              smooth={true}
              duration={300}
              offset={-100}
              to="about"
            >
              About
            </Link>
          </li>
          <li>
            <Link
              className="link"
              activeClass={'active-link'}
              spy={true}
              smooth={true}
              duration={300}
              offset={-100}
              to="work"
            >
              Experiences
            </Link>
          </li>
          <li>
            <Link
              className="link"
              activeClass={'active-link'}
              spy={true}
              smooth={true}
              offset={-100}
              duration={300}
              to="project"
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              className="link"
              activeClass={'active-link'}
              spy={true}
              smooth={true}
              duration={300}
              offset={-80}
              to="contact"
            >
              Contact
            </Link>
          </li>
        </ul>
        <div
          className={active ? 'burger burger-active' : 'burger'}
          onClick={handleClick}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </nav>
    </div>
  );
}
